<template>
    <div>
        <el-dialog :close-on-click-modal="false"   :title="dataMap.title" :visible.sync="dataMap.visible" :before-close="resetDialog"  width="70%">
            <div class="base-info">
                <el-row>
                    <el-col :span="6">
                        <span class="top-info">卖家：{{orderData.seller}}</span>
                    </el-col>
                    <el-col :span="6">
                        <span class="top-info">买家：{{orderData.buyer}}</span>
                    </el-col>
                    <el-col :span="7">
                        <span class="top-info"> 买家姓名/邮箱：{{orderData.cons}}/{{orderData.eMail}}</span>
                    </el-col>
                    <el-col :span="5">
                        <span class="top-info">包裹总额：{{orderData.coinType}}&nbsp;{{orderData.actPay}}</span>
                    </el-col>
                </el-row>
            </div>
            <div class="order-state">
                <div class="progress-state">
                    <div class="state-div">
                        <div v-for="item in progress" :class="item.class">{{item.label}}</div>
                    </div>
                </div>
            </div>
            <div class="mid-plan">
                <div class="plan-tit">
                    <span v-text="planTit"></span>
                    <el-button type="text" icon="el-icon-edit" v-show="btnFlag" @click="editInfo">编辑</el-button>
                    <el-button type="text" icon="el-icon-circle-check" v-show="btnFlag_2" @click="saveInfo" style="margin-right: 120px">保存</el-button>
                    <el-button type="text" icon="el-icon-refresh" v-show="btnFlag_2" @click="resetInfo" style="margin-right: 60px">重置</el-button>
                    <el-button type="text" icon="el-icon-back" v-show="btnFlag_2" @click="goBack">返回</el-button>

                </div>
                <el-tabs v-model="dataMap.activeTab"  tab-position="left" style="height: 250px;" @tab-click="handleClick">
                    <el-tab-pane name="1" label="收货地址" class="sh-address">
                        <span slot="label">收货地址<svg-icon :icon-class="addressFlag?'right':'error'" /></span>
                        <el-form :model="shipForm" ref="shipForm" label-position="right">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="收件人:" prop="recipient">
                                        <el-input size="small" v-model="shipForm.recipient" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.recipient"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="电 话:" prop="phone">
                                        <el-input size="small" v-model="shipForm.phone" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.phone"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="手 机:" prop="mobilePhone">
                                        <el-input size="small" v-model="shipForm.mobilePhone" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.mobilePhone"></span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="国家/地区:" prop="country">
                                        <el-input size="small" v-model="shipForm.country" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.country"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="省/州:" prop="province">
                                        <el-input size="small" v-model="shipForm.province" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.province"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="城 市:" prop="city">
                                        <el-input size="small" v-model="shipForm.city" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.city"></span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="地址1:" prop="addr1">
                                        <el-input size="small" v-model="shipForm.addr1" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.addr1"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="门牌号:" prop="houseNum">
                                        <el-input size="small" v-model="shipForm.houseNum" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.houseNum"></span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="地址2:" prop="addr2">
                                        <el-input size="small" v-model="shipForm.addr2" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.addr2"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="邮 编:" prop="ZipCode">
                                        <el-input size="small" v-model="shipForm.ZipCode" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.ZipCode"></span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="公 司:" prop="company">
                                        <el-input size="small" v-model="shipForm.company" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.company"></span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="税 号:" prop="ein">
                                        <el-input size="small" v-model="shipForm.ein" v-show="isAddrEdit"></el-input>
                                        <span v-show="!isAddrEdit" v-text="shipForm.ein"></span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <!--                    <el-tab-pane name="2" label="报关信息" class="bg-plan">-->
                    <!--                        <span slot="label">报关信息 <svg-icon :icon-class="customFlag?'right':'error'" /></span>-->
                    <!--                        <div class="bg-default" v-show="ifShowBG">-->
                    <!--                            <el-checkbox v-model="ifManual" @change="ifManualChange">开启手动报关</el-checkbox>-->
                    <!--                            <span style="margin-left: 30px;color: #bab8b8">（用于解决报关信息 “超长” 或 “过多” 问题，开启后将停用现有报关信息）</span>-->
                    <!--                            <div class="bg-tab">-->
                    <!--                                <el-table :header-row-style="{height:'30px'}" :header-cell-style="{padding:'0px'}" :row-style="{height:'30px'}" :cell-style="{padding:'0px'}" :data="customData" border height="220" style="width: 100%;">-->
                    <!--                                    <el-table-column label="SKU" align="center" prop=""></el-table-column>-->
                    <!--                                    <el-table-column label="报关信息" align="left" header-align="center" prop="tempId"></el-table-column>-->
                    <!--                                </el-table>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class="bg-edit" v-show="!ifShowBG">-->
                    <!--                            <div class="form-div">-->
                    <!--                                <el-form>-->
                    <!--                                    <el-row>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="中文名称">-->
                    <!--                                                <el-input size="small"></el-input>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="英文名称">-->
                    <!--                                                <el-input size="small"></el-input>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                    </el-row>-->
                    <!--                                    <el-row>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="申报金额">-->
                    <!--                                                <el-input size="small"></el-input>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="申报重量">-->
                    <!--                                                <el-input size="small"></el-input>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                    </el-row>-->
                    <!--                                    <el-row>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="海关编码">-->
                    <!--                                                <el-input size="small"></el-input>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                        <el-col :span="12">-->
                    <!--                                            <el-form-item label="报关属性">-->
                    <!--                                                <el-checkbox v-model="manualForm.ck1" @change="ifCk1_1" style="margin-right: 5px !important;">含电</el-checkbox>-->
                    <!--                                                <el-select clearable  v-model="manualForm.ck" size="mini" style="width: 70px;margin-right: 5px" v-show="ifShowS_1">-->
                    <!--                                                    <el-option value="含电">含电</el-option>-->
                    <!--                                                    <el-option value="纯电">纯电</el-option>-->
                    <!--                                                </el-select>-->
                    <!--                                                <el-checkbox v-model="manualForm.ck2" style="right: 0px;float: right">含非液体化妆品-->
                    <!--                                                    <el-tooltip content="仅速买通报关生效" placement="top" effect="light">-->
                    <!--                                                        <i class="el-icon-info"></i>-->
                    <!--                                                    </el-tooltip>-->
                    <!--                                                </el-checkbox>-->
                    <!--                                            </el-form-item>-->
                    <!--                                        </el-col>-->
                    <!--                                    </el-row>-->
                    <!--                                    <el-row style="text-align: center">-->
                    <!--                                        注：[含非液体化妆品] 仅对速卖通平台有效-->
                    <!--                                    </el-row>-->
                    <!--                                </el-form>-->
                    <!--                            </div>-->
                    <!--                            <div class="normal-bg-list">-->
                    <!--                                <div class="normal-tit">-->
                    <!--                                    <span>常用报关</span>-->
                    <!--                                    <el-button type="text" size="small" style="float: right;">+添加</el-button>-->
                    <!--                                </div>-->

                    <!--                                <div class="normal-body">-->
                    <!--                                    <a>报关-旗帜</a>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </el-tab-pane>-->
                    <el-tab-pane name="3" label="物流信息" class="wl-plan">
                        <span slot="label">物流信息 <svg-icon :icon-class="flowForm.expreMode != null && flowForm.wayBillNum != null ?'right':'error'" /></span>
                        <el-form :model="flowForm">
                            <!--                            <el-form-item label="买家指定:">-->
                            <!--                                <el-input size="small" v-model="flowForm.buyerDesi" style="width: 200px"></el-input>-->
                            <!--                            </el-form-item>-->
                            <!--                            <el-form-item label="获取方式:">-->
                            <!--                                <el-radio-group v-model="flowForm.getMode" prop="type">-->
                            <!--                                    <el-radio :label="-1">无</el-radio>-->
                            <!--                                    <el-radio :label="0">自动获取</el-radio>-->
                            <!--                                    <el-radio :label="1">手动上传</el-radio>-->
                            <!--                                </el-radio-group>-->
                            <!--                            </el-form-item>-->
                            <el-form-item label="物流方式:">
                                <el-select clearable  v-model="flowForm.expreMode" size="small" placeholder="请选择物流方式" style="width: 200px">
                                    <el-option value="云途" label="云途"></el-option>
                                    <el-option value="EMS" label="EMS"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物流单号:">
                                <el-input v-model.trim="flowForm.wayBillNum" size="small" placeholder="请输入运单号" style="width: 200px"></el-input>
                            </el-form-item>
                            <!--                            <el-form-item label="预估运费:">-->
                            <!--                                <el-input size="small" v-model="flowForm.getType" style="width: 200px"></el-input>-->
                            <!--                            </el-form-item>-->
                            <el-form-item label="" label-width="71px">
                                <el-button type="warning" plain size="small" @click="editExpre">确定修改</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!--                    <el-tab-pane name="4" label="货源采购信息" class="hy-plan">-->
                    <!--                        <span slot="label">货源采购信息</span>-->
                    <!--                        <el-row>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>采购单:</span></div><span>e3209321123</span>-->
                    <!--                            </el-col>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>采购员:</span></div><span>李欣</span>-->
                    <!--                            </el-col>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>状态:</span></div><span>已到货</span>-->
                    <!--                            </el-col>-->
                    <!--                        </el-row>-->
                    <!--                        <el-row>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>创建时间:</span></div><span></span>-->
                    <!--                            </el-col>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>仓库位置:</span></div><span></span>-->
                    <!--                            </el-col>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>供货商名称:</span></div><span></span>-->
                    <!--                            </el-col>-->
                    <!--                        </el-row>-->
                    <!--                        <el-row>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>运单号:</span></div>-->
                    <!--                            </el-col>-->
                    <!--                            <el-col :span="8">-->
                    <!--                                <div class="hy-label"><span>采购备注:</span></div>-->
                    <!--                            </el-col>-->
                    <!--                        </el-row>-->
                    <!--                        <el-row class="last-row-cg">-->
                    <!--                            <el-col class="tab-info-wl">-->
                    <!--                                <span class="info-tit">商品总价:</span>-->
                    <!--                                <span class="info-con">8.00</span>-->
                    <!--                                <span class="info-tit"> 运费:</span>-->
                    <!--                                <span class="info-con">0.00</span>-->
                    <!--                                <span class="info-tit">其他费用:</span>-->
                    <!--                                <span class="info-con">0.00</span>-->
                    <!--                                <span class="info-tit">应付总价:</span>-->
                    <!--                                <span class="info-con info-price">8.00</span>-->
                    <!--                            </el-col>-->
                    <!--                        </el-row>-->
                    <!--                        <el-table class="hy-tab" border style="width: 100%;">-->
                    <!--                            <el-table-column label="商品信息" align="center"></el-table-column>-->
                    <!--                            <el-table-column label="单价" align="center"></el-table-column>-->
                    <!--                            <el-table-column label="已到货/总数量" align="center"></el-table-column>-->
                    <!--                        </el-table>-->
                    <!--                    </el-tab-pane>-->
                    <el-tab-pane name="5" label="备注信息" class="bg-plan">
                        <span slot="label">备注信息 </span>
                        <el-table :header-row-style="{height:'30px'}" :header-cell-style="{padding:'0px'}" :row-style="{height:'30px'}" :cell-style="{padding:'0px'}"  border style="width: 100%;" :data="remarkData" height="220">
                            <el-table-column label="内容" align="center" prop="remarkContent"></el-table-column>
                            <el-table-column label="时间" align="center" prop="opeTime"></el-table-column>
                            <el-table-column label="类型" align="center" prop="remarkType" :formatter="remarkTypeFormat" width="100"></el-table-column>
                            <el-table-column label="操作人" align="center" prop="opeNo" width="80"></el-table-column>
                            <el-table-column label="操作" align="center" width="100">
                                <template slot-scope="props">
                                    <el-button class="remark-btn" type="text" v-if="props.row.remarkType == '1'" @click="editNote(props.row)">编辑</el-button>
                                    <el-button class="remark-btn" type="text" @click="deleteNote(props.row.REMARK_ID)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="bottom-tab">
                <el-table border style="width: 100%;" :data="skuData">
                    <el-table-column label="订单号" align="left" width="180">
                        <template scope="props">
                            <span style="font-size: 12px;color: #409eff">{{orderData.sAppNo}}</span><br/>
                            <el-tooltip content="123456" placement="bottom" effect="light">
                                <el-tag class="tag-bz">备</el-tag>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品信息" align="center" prop="">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <div style="width: 60px;height: 60px">
                                    <img v-if="scope.row.picAddr != null" :src="scope.row.picAddr" height="60px" width="60px">
                                    <img v-else src="../../assets/images/kong.png" height="60px" width="60px">
                                </div>
                                <div style="font-size: 13px;text-align: left">
                                    <el-row class="order-sku"><a :href="scope.row.prodLink" target="_blank" style="text-decoration: none">{{scope.row.skuName}}</a><span>×</span><div class="p-num">{{scope.row.num}}</div></el-row>
                                    <div>{{orderData.coinType}} {{scope.row.price}}</div>
                                    <div v-for="item in scope.row.skuAttr">{{item}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品标题" align="left" header-align="center" prop="prodTitle"></el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="warning" size="small" v-if ="status == '4'" @click="processOrder">审核</el-button>
                <el-button type="warning" size="small" v-if ="status == '5'" @click="getWayBillNum">申请运单号</el-button>
                <el-button type="warning" size="small" v-if ="status =='6'">打印面单</el-button>
                <el-button type="warning" size="small" v-if ="status =='6'">打印拣货单</el-button>
                <el-button type="warning" size="small" v-if ="status =='7'">发货</el-button>
                <el-button type="warning" size="small" v-if ="status =='10'" @click="restore">还原</el-button>
                <el-dropdown style="margin: 0 10px" @command="exceptionHandel">
                    <el-button type="primary" plain size="small">
                        异常处理<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="gz">移入搁置</el-dropdown-item>
                        <el-dropdown-item command="fp">优先分配库存</el-dropdown-item>
                        <el-dropdown-item command="bj">标记黑名单</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" plain size="small" @click="addNote">备注</el-button>
                <el-button type="primary" size="small" @click="closeDetailDialog">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="手动报关" :visible.sync="visible2" width="400px" @close="closeDialog2">
            <el-form :model="manualForm" class="dialog-manual-form">
                <el-form-item label="中文名称"><el-input size="small" v-model="manualForm.ChineseName"></el-input></el-form-item>
                <el-form-item label="英文名称"><el-input size="small" v-model="manualForm.EnglishName"></el-input></el-form-item>
                <el-form-item label="申报金额">
                    <el-input size="small" v-model="manualForm.amount">
                        <template slot="append" style="width: 30px">USD</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="申报重量">
                    <el-input size="small" v-model="manualForm.weight">
                        <template slot="append" style="width: 30px">g</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="申报数量"><el-input size="small" v-model="manualForm.num"></el-input></el-form-item>
                <el-form-item label="海关编码"><el-input size="small" v-model="manualForm.code"></el-input></el-form-item>
                <el-form-item label="报关属性">
                    <el-checkbox v-model="manualForm.ck1" @change="ifCk1" style="margin-right: 5px !important;">含电</el-checkbox>
                    <el-select clearable  v-model="manualForm.ck" size="mini" style="width: 70px;margin-right: 5px" v-show="ifShowS">
                        <el-option value="含电">含电</el-option>
                        <el-option value="纯电">纯电</el-option>
                    </el-select>
                    <el-checkbox v-model="manualForm.ck2" style="right: 0px;float: right">含非液体化妆品
                        <el-tooltip content="仅速买通报关生效" placement="top" effect="light">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </el-checkbox>

                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer dig-2-ft">
                <span >总价:0.00</span>
                <span class="sp1">USD</span>
                <span class="sp2">总重量:0.00</span>
                <span class="sp3">g</span>
                <el-button type="primary" size="small">确 定</el-button>
                <el-button  size="small">取 消</el-button>
            </div>
        </el-dialog>
        <order-note :noteData="noteData" ref="orderNote" :loadNoteList="loadNoteList"></order-note>
        <el-dialog :close-on-click-modal="false"   title="标记原因" :visible.sync="blackVisible" width="500px" class="black-dialog" :before-close="beforeCloseBlack">
            <div>
                <div style="padding: 10px 0 0 20px"><span style="color: red">*</span><span>你认为该买家存在什么不良行为？</span></div>
                <el-radio-group class="black-cause-radio" v-model="blackCause">
                    <el-radio :label="1">频繁退货、退款</el-radio>
                    <el-radio :label="2">恶意差评（不合理要求、同行等等）</el-radio>
                    <el-radio :label="3"> 疑似信用卡诈骗</el-radio>
                    <el-radio :label="4"> 恶意威胁、敲诈</el-radio>
                    <el-radio :label="5"> 拍下不付款</el-radio>
                    <el-radio :label="6"> 偏远地区</el-radio>
                    <el-radio :label="7">
                        其他<el-input v-model="otherCause" size="small" style="width: 300px;margin-left: 20px" v-show="blackCause == 7" placeholder="说明原因，不超过十个字，选填"></el-input>
                    </el-radio>
                </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitBlackList">确 定</el-button>
                <el-button  size="small" @click="closeBlackDialog">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="审核" :visible.sync="processOrderVisible" width="20%">
            <div style="margin: 20px">
                <el-radio v-model="handleNum" label="1">启动采购流程</el-radio>
                <el-radio v-model="handleNum" label="2">移入待交运</el-radio>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="processOrderVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="choseHandleNum">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import orderNote from './orderNote'
    import {getOrderDetail,getNoteList,deleteRemark,updateOrderState,moveToBlack,updataExpre} from '@/api/order/all'
    import {mapGetters} from 'vuex'
    export default {
        name: "orderDetail",
        components:{orderNote},
        props:{
            dataMap:{
                type:Object,
                default:function () {
                    return{
                        visible:false,
                        title:'',
                        activeTab:'1'
                    }
                }
            },
        },
        data(){
            return{
                appId:'',
                status:'',
                visible2:false,
                visible3:false,
                blackVisible:false,//黑名单dialog
                processOrderVisible:false,//处理订单提示窗口
                closeOnClickModal:false,
                planTit:"收货地址",
                btnFlag:false,
                btnFlag_2:false,
                isAddrEdit:false,//
                index:0,
                progress:[
                    {class:'state-0 state-0-img1',label:'已处理'},
                    {class:'state-0 state-0-img2',label:'已申请单号'},
                    {class:'state-0 state-0-img2',label:'已打拣货单'},
                    {class:'state-0 state-0-img2',label:'已打面单'},
                    {class:'state-0 state-0-img3',label:'已发货'}
                ],
                orderData:{
                    // seller:null,//卖家
                    // buyer:null,//买家
                    // email:null,//邮箱
                },
                shipForm:{
                    recipient:null,//收件人
                    phone:null,//电话
                    mobilePhone:null,//手机
                    country:null,//国家地区
                    province:null,//省- 州
                    city:null,//城市
                    addr1:null,//地址1
                    addr2:null,//地址2
                    company:null,//公司
                    houseNum:null,//门牌号
                    ZipCode:null,//右边
                    ein:null //税号
                },
                ifManual:false,//是否手动报关
                manualForm:{
                    ChineseName:null,//中文名称
                    EnglishName:null,//英文名称
                    amount:0.00,//申报金额
                    weight:0.00,//申报重量
                    num:null,//申报数量
                    code:null,//海关编码
                    ck:null,//含电程度
                    ck1:false,//报关属性
                    ck2:false,//报关属性
                },
                ifShowS:false,//是否显示含电下拉框
                ifShowS_1:false,
                ifShowBG:true,//默认显示报关信息列表
                flowForm:{
                    buyerDesi:'无',//买家指定
                    getMode:-1,//获取方式
                    expreMode:null,//物流方式
                    wayBillNum:null,//运单号
                },
                noteForm:{
                    appId:'',
                    type:'',
                    note:null,//备注
                    color:''
                },
                noteData:{
                    visible:false,
                    appId:null,
                    source:null
                },
                skuData:[],//商品信息数据
                customData:[],//报关数据
                remarkData:[],
                activeNum:0,
                pickPrintFlag:false,
                facePrintFlag:false,
                blackCause:null,//标记黑名单原因
                otherCause:null,//其他原因（手动输入）
                handleNum:null,//审核弹框中是启动采购流程还是直接移入待交运
            }
        },
        computed:{
            addressFlag(){
                if(this.shipForm.recipient != null && this.shipForm.country != null && this.shipForm.province !=null && this.shipForm.city != null && this.shipForm.addr1 != null){
                    return true;
                }else{
                    return false;
                }
            },
            customFlag(){
                if(this.customData.length > 0){
                    return true;
                }else{
                    return false;
                }
            },
            ...mapGetters(['orderStatus']),
            //订单状态列表
            stateList(){
                return this.orderStatus;
            }
        },
        watch:{
            btnFlag:function () {
                if(this.btnFlag == true){
                    this.btnFlag_2 = false;
                    this.isAddrEdit = false;
                }
            },
            btnFlag_2:function () {
                if(this.btnFlag_2 == true){
                    this.btnFlag = false;
                }
            }
        },
        created(){

        },
        methods:{
            addNote(){
                this.noteData.visible = true;
                this.noteData.appId = this.appId;
                this.noteData.source = 0;//0表示会点击弹框中的备注按钮，1表示点击列表中的备注按钮
                this.$refs.orderNote.loadNote(this.appId);
            },
            loadOrderDetail(param){
                let that = this;
                this.appId=param.appId;
                this.status =param.status;
                this.activeNum = Number(param.status);
                getOrderDetail(param.appId).then(res =>{
                    res.data.skuList.forEach(item =>{
                        if(item.hasOwnProperty('skuAttr') && item.skuAttr != null){
                            let attr = item.skuAttr.split(',');
                            item.skuAttr = attr;
                        }
                    });
                    that.skuData = res.data.skuList;
                    that.customData = res.data.customList;
                    that.orderData = res.data;
                    that.shipForm.recipient = res.data.cons;
                    that.shipForm.phone = res.data.phone;
                    that.shipForm.mobilePhone = res.data.mobilePhone;
                    that.shipForm.country = res.data.country;
                    that.shipForm.province = res.data.province;
                    that.shipForm.city = res.data.city;
                    that.shipForm.addr1 = res.data.addr1;
                    that.shipForm.addr2 = res.data.addr2;
                    that.shipForm.company = res.data.company;
                    that.shipForm.houseNum = res.data.houseNum;
                    that.shipForm.ZipCode = res.data.post;
                    that.shipForm.ein = res.data.ein;
                    that.pickPrintFlag = res.data.pickPrintFlag;
                    that.facePrintFlag = res.data.facePrintFlag;
                    that.flowForm.expreMode = res.data.expre[0] ? res.data.expre[0].expreMode:null,
                        that.flowForm.wayBillNum = res.data.expre[0] ? res.data.expre[0].trackNo:null,
                        that.setProgresStyle();
                }).catch(err =>{console.log(err);})
                this.loadNoteList();
            },

            loadNoteList(){
                getNoteList(this.appId).then(res => {
                    this.remarkData = res.data;
                })
            },

            handleClick(tab, event) {
                // this.index = tab.index;
                // if(tab.index == 0 || tab.index == 2){
                //     this.btnFlag = true;
                // }else{
                //     this.btnFlag = false;
                // }
                this.planTit = tab.label;
            },
            editInfo:function () {
                this.btnFlag = false;
                this.btnFlag_2 = true;
                if(this.index == 0){
                    this.isAddrEdit = true;
                }else if(this.index == 1){
                    this.ifShowBG = false;
                }else if(this.index == 2){

                }
            },
            saveInfo:function () {

            },
            resetInfo:function () {
                if(this.index == 0){
                    this.$refs['shipForm'].resetFields();
                }else if(this.index == 1){

                }
            },
            goBack:function () {
                if(this.index == 0){
                    this.btnFlag = true;
                    this.btnFlag_2 = false;
                    this.isAddrEdit = false;
                }else if(this.index == 1){
                    this.btnFlag = false;
                    this.btnFlag_2 = false;
                    this.isAddrEdit = false;
                    this.ifShowBG = true;

                }

            },
            //选中或取消 是否手动报关选项
            ifManualChange:function (val) {
                if(val == true){
                    this.visible2 = true;
                }
            },
            //是否含电
            ifCk1:function (val) {
                if(val){
                    this.ifShowS = true;
                }else{
                    this.ifShowS = false;
                }
            },
            ifCk1_1:function (val) {
                if(val){
                    this.ifShowS_1 = true;
                }else{
                    this.ifShowS_1 = false;
                }
            },
            closeDialog2:function () {
                this.ifManual = false;
            },
            closeDetailDialog(){
                this.dataMap.visible = false;
            },
            //关闭弹窗回调
            resetDialog(done){
                this.$refs['shipForm'].resetFields();
                Object.assign(this.$data, this.$options.data.call(this));
                done();
            },
            //申请运单号
            getWayBillNum(){
                console.log(this.flowForm)
            },
            setProgresStyle(){
                let hasDone = [];
                //根据完成的步骤数设置进度样式
                console.log(this.activeNum);
                if(this.pickPrintFlag){
                    hasDone.push("已打拣货单");
                }
                if(this.facePrintFlag){
                    hasDone.push("已打面单");
                }
                if(this.activeNum > 4 && this.activeNum != 9 && this.activeNum != 10){
                    hasDone.push("已处理");
                }
                if(this.activeNum >= 8 && this.activeNum != 9 && this.activeNum != 10 ){
                    hasDone.push("已发货");
                }
                //设置进度条样式
                this.progress.forEach(item =>{
                    let num = "2";
                    if (item.label == "已处理") num = "1";
                    else if (item.label == "已发货") num = "3";

                    if(hasDone.indexOf(item.label) > -1){
                        item.class = 'state-1 state-1-img' + num;
                    }else{
                        item.class = 'state-0 state-0-img' + num;
                    }
                });
            },
            //处理订单
            processOrder(row){
                this.handleNum = null;
                this.processOrderVisible = true;
            },
            //'处理'弹窗确定按钮
            choseHandleNum() {
                let that = this;
                this.processOrderVisible = false;
                if (this.handleNum == 1) {
                    this.$message({
                        message: '改功能还未实现！',
                        center: true,
                    });
                } else if (this.handleNum == 2) { //移入带交运
                    let param = {'appId': this.appId, 'state': '5'};
                    updateOrderState(param).then(res => {
                        if (res.code == '200') {
                            this.$message({
                                message: '订单移入待交运成功！',
                                type: 'success',
                                center: true,
                            });
                        }
                    });
                }
            },
            remarkTypeFormat(row){
                if(row.remarkType == '0'){
                    return '客服备注';
                }else if(row.remarkType == '1'){
                    return '拣货说明';
                }else {
                    return "未知";
                }
            },
            editNote(row){
                console.log(row);
                this.noteData.visible = true;
                this.noteData.appId = row.appId;
                this.noteData.source = 0;//0表示会点击弹框中的备注按钮，1表示点击列表中的备注按钮
                this.$refs.orderNote.loadNote(row.appId);
            },
            deleteNote(id){
                this.$confirm('确定删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRemark(id).then(res => {
                        if(res.code == '200'){
                            this.$message.success("删除成功！");
                            this.loadNoteList();
                        }else{
                            this.$message.error("删除失败！")
                        }
                    }).catch( err => {
                        this.$message.error("删除失败！")
                    });
                }).catch(() => {

                });

            },
            //还原
            restore(){
                let param = {'appId':this.appId,'state':this.orderData.BEFORE_SHELVE_STATE,'shelveFlag':false};
                updateOrderState(param).then(res => {
                    if(res.code == '200'){
                        this.$message.success("已还原订单！");
                        this.dataMap.visible = false;
                        this.getList();
                    }else{
                        this.$message.error("还原订单失败！");
                    }
                });
            },
            //异常处理
            exceptionHandel(val){
                let gz = this.stateList.filter( item => {
                    return item.dictLabel == '已搁置';
                });
                if(val == 'gz'){ //移入搁置
                    let param = {'appId':this.appId,'state':gz[0].dictValue,'shelveFlag':true,'beforeShelveState':this.status};
                    this.$confirm('确定搁置订单吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() =>{
                        updateOrderState(param).then(res => {
                            if(res.code == '200'){
                                this.$message.success("已搁置订单！");
                                this.dataMap.visible = false;
                                this.getList();
                            }else{
                                this.$message.error("搁置订单失败！");
                            }
                        });
                    }).catch(err => {

                    })
                }
                if(val == 'bj'){
                    this.blackVisible = true;
                }

            },
            //关闭标记黑名单弹框
            closeBlackDialog(){
                this.blackVisible = false;
                this.clearBlackForm();
            },
            beforeCloseBlack(done){
                this.clearBlackForm();
                done();
            },
            clearBlackForm(){
                this.blackCause = null;
                this.otherCause = null;
            },
            //标记黑名单提交
            submitBlackList(){
                this.$confirm('确定添加到黑名单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    moveToBlack(this.appId).then(res => {
                        if(res.code == '200'){
                            this.$message.success("操作成功！")
                        }
                    }).catch(err =>{});
                })
            },
            //物流修改
            editExpre(){
                let params = {
                    expreId:this.orderData.expre.length >0? this.orderData.expre[0].expreId:null,
                    expreMode:this.flowForm.expreMode,
                    trackNo:this.flowForm.wayBillNum,
                }
                updataExpre(params).then(res =>{
                    if(res.code == 200){
                        this.$message.success("修改成功！")
                    }
                }).catch(err =>{});
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .base-info .top-info{color: black;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif}
    .order-detail .base-info .el-row >>>.el-col {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
</style>
